import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'sl_cookie_consent';

const CATEGORIES = [
  {
    id: 'essential',
    label: 'Essential Cookies',
    desc: 'Required for the website to function. Cannot be disabled.',
    locked: true,
  },
  {
    id: 'analytics',
    label: 'Analytics Cookies',
    desc: 'Help us understand how visitors interact with the website.',
    locked: false,
  },
  {
    id: 'marketing',
    label: 'Marketing Cookies',
    desc: 'Used to deliver relevant ads and track campaign performance.',
    locked: false,
  },
];

export default function CookieConsent() {
  const [visible, setVisible]       = useState(false);
  const [leaving, setLeaving]       = useState(false);
  const [showPrefs, setShowPrefs]   = useState(false);
  const [prefs, setPrefs]           = useState({ essential: true, analytics: false, marketing: false });

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      const t = setTimeout(() => setVisible(true), 2600);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = (choice) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(choice));
    setLeaving(true);
    setTimeout(() => setVisible(false), 420);
  };

  const acceptAll = () => dismiss({ essential: true, analytics: true, marketing: true });

  const savePrefs = () => dismiss(prefs);

  const toggle = (id) => setPrefs(p => ({ ...p, [id]: !p[id] }));

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes sl-cookie-in  { from { transform:translateX(-50%) translateY(110%); opacity:0; } to { transform:translateX(-50%) translateY(0); opacity:1; } }
        @keyframes sl-cookie-out { from { transform:translateX(-50%) translateY(0);    opacity:1; } to { transform:translateX(-50%) translateY(110%); opacity:0; } }
        .sl-cookie-banner {
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% - 32px);
          max-width: 860px;
          z-index: 99998;
          background: linear-gradient(135deg, #0d1829 0%, #0a1525 100%);
          border: 1px solid rgba(0,212,255,0.28);
          border-radius: 16px;
          padding: 22px 28px;
          box-shadow: 0 8px 48px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,212,255,0.06) inset;
          display: flex;
          align-items: center;
          gap: 24px;
          animation: sl-cookie-in 0.42s cubic-bezier(0.34,1.56,0.64,1) forwards;
        }
        .sl-cookie-banner.leaving {
          animation: sl-cookie-out 0.38s ease-in forwards;
        }
        .sl-cookie-icon {
          font-size: 2rem;
          flex-shrink: 0;
          filter: drop-shadow(0 0 8px rgba(0,212,255,0.4));
        }
        .sl-cookie-text { flex: 1; min-width: 0; }
        .sl-cookie-text h4 {
          font-family: var(--font-display);
          font-size: 0.95rem;
          font-weight: 700;
          color: #fff;
          margin: 0 0 4px;
        }
        .sl-cookie-text p {
          font-size: 0.8rem;
          color: rgba(255,255,255,0.6);
          line-height: 1.55;
          margin: 0;
        }
        .sl-cookie-text a { color: #00d4ff; text-decoration: underline; font-weight: 600; }
        .sl-cookie-actions { display: flex; gap: 10px; flex-shrink: 0; align-items: center; }
        .sl-btn-accept {
          background: linear-gradient(135deg, #0066ff, #00d4ff);
          color: #fff; border: none; border-radius: 8px;
          padding: 9px 20px; font-family: var(--font-display);
          font-size: 0.82rem; font-weight: 700; cursor: pointer;
          white-space: nowrap; box-shadow: 0 4px 16px rgba(0,102,255,0.35);
          transition: opacity 0.2s;
        }
        .sl-btn-accept:hover { opacity: 0.88; }
        .sl-btn-essential {
          background: transparent; color: rgba(255,255,255,0.65);
          border: 1px solid rgba(255,255,255,0.18); border-radius: 8px;
          padding: 9px 16px; font-family: var(--font-display);
          font-size: 0.82rem; font-weight: 600; cursor: pointer;
          white-space: nowrap; transition: all 0.2s;
        }
        .sl-btn-essential:hover { border-color: rgba(255,255,255,0.4); color: #fff; }
        .sl-cookie-close {
          background: none; border: none; color: rgba(255,255,255,0.3);
          font-size: 1.1rem; cursor: pointer; padding: 4px;
          line-height: 1; flex-shrink: 0; transition: color 0.2s;
        }
        .sl-cookie-close:hover { color: rgba(255,255,255,0.7); }

        /* Preferences panel */
        .sl-cookie-prefs {
          margin-top: 16px;
          border-top: 1px solid rgba(0,212,255,0.15);
          padding-top: 16px;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .sl-pref-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 10px;
          padding: 12px 14px;
        }
        .sl-pref-info { flex: 1; min-width: 0; }
        .sl-pref-info strong { display: block; color: #fff; font-size: 0.82rem; margin-bottom: 2px; }
        .sl-pref-info span { color: rgba(255,255,255,0.5); font-size: 0.74rem; line-height: 1.4; }
        .sl-toggle {
          position: relative; width: 40px; height: 22px;
          flex-shrink: 0; cursor: pointer;
        }
        .sl-toggle input { opacity: 0; width: 0; height: 0; position: absolute; }
        .sl-toggle-track {
          position: absolute; inset: 0; border-radius: 11px;
          background: rgba(255,255,255,0.12); transition: background 0.2s;
        }
        .sl-toggle input:checked + .sl-toggle-track { background: #0066ff; }
        .sl-toggle-thumb {
          position: absolute; top: 3px; left: 3px;
          width: 16px; height: 16px; border-radius: 50%;
          background: #fff; transition: transform 0.2s;
          pointer-events: none;
        }
        .sl-toggle input:checked ~ .sl-toggle-thumb { transform: translateX(18px); }
        .sl-locked-badge {
          font-size: 0.68rem; color: rgba(0,212,255,0.8);
          background: rgba(0,212,255,0.1); border: 1px solid rgba(0,212,255,0.25);
          border-radius: 4px; padding: 2px 7px; white-space: nowrap;
        }
        .sl-prefs-save {
          background: linear-gradient(135deg, #0066ff, #00d4ff);
          color: #fff; border: none; border-radius: 8px;
          padding: 10px; font-family: var(--font-display);
          font-size: 0.85rem; font-weight: 700; cursor: pointer;
          width: 100%; transition: opacity 0.2s; margin-top: 4px;
        }
        .sl-prefs-save:hover { opacity: 0.88; }

        @media (max-width: 640px) {
          @keyframes sl-cookie-in  { from { transform:translateY(110%); opacity:0; } to { transform:translateY(0); opacity:1; } }
          @keyframes sl-cookie-out { from { transform:translateY(0); opacity:1; } to { transform:translateY(110%); opacity:0; } }
          .sl-cookie-banner {
            display: grid;
            grid-template-columns: auto 1fr auto;
            grid-template-rows: auto auto;
            align-items: start;
            gap: 10px;
            padding: 16px 16px 18px;
            bottom: 0; border-radius: 18px 18px 0 0;
            width: 100%; left: 0; transform: none;
          }
          .sl-cookie-icon {
            grid-column: 1; grid-row: 1;
            font-size: 1.25rem; align-self: center;
            filter: drop-shadow(0 0 6px rgba(0,212,255,0.55));
          }
          .sl-cookie-text { grid-column: 2; grid-row: 1; align-self: center; }
          .sl-cookie-text h4 { font-size: 0.84rem; margin-bottom: 2px; }
          .sl-cookie-text p { font-size: 0.72rem; line-height: 1.45; }
          .sl-cookie-close { grid-column: 3; grid-row: 1; align-self: start; position: static; font-size: 1rem; padding: 2px 4px; }
          .sl-cookie-actions { grid-column: 1 / -1; grid-row: 2; width: 100%; gap: 8px; display: flex; }
          .sl-btn-accept { flex: 1.4; text-align: center; padding: 9px 10px; font-size: 0.8rem; }
          .sl-btn-essential { flex: 1; text-align: center; padding: 9px 10px; font-size: 0.8rem; }
          .sl-cookie-prefs { grid-column: 1 / -1; }
          .sl-pref-row { padding: 9px 12px; }
          .sl-pref-info strong { font-size: 0.78rem; }
          .sl-pref-info span { font-size: 0.69rem; }
        }
      `}</style>

      <div className={`sl-cookie-banner${leaving ? ' leaving' : ''}`}
           style={{ flexWrap: 'wrap' }}
           role="dialog" aria-label="Cookie consent">

        <div className="sl-cookie-icon">🍪</div>

        <div className="sl-cookie-text">
          <h4>We use cookies &amp; local storage</h4>
          <p>
            We use essential cookies to keep the site working and analytics cookies to understand how visitors use it.
            By clicking <strong style={{ color:'#fff' }}>Accept All</strong> you consent to all cookies.{' '}
            <a href="/privacy-policy" onClick={e => e.stopPropagation()}>Privacy Policy</a>
          </p>
        </div>

        <div className="sl-cookie-actions">
          <button className="sl-btn-accept" onClick={acceptAll}>Accept All</button>
          <button className="sl-btn-essential" onClick={() => setShowPrefs(p => !p)}>
            {showPrefs ? 'Hide Options' : 'Manage Preferences'}
          </button>
        </div>

        <button className="sl-cookie-close" onClick={() => dismiss('dismissed')} aria-label="Close">✕</button>

        {/* Preferences panel */}
        {showPrefs && (
          <div className="sl-cookie-prefs">
            {CATEGORIES.map(cat => (
              <div key={cat.id} className="sl-pref-row">
                <div className="sl-pref-info">
                  <strong>{cat.label}</strong>
                  <span>{cat.desc}</span>
                </div>
                {cat.locked ? (
                  <span className="sl-locked-badge">Always On</span>
                ) : (
                  <label className="sl-toggle">
                    <input
                      type="checkbox"
                      checked={prefs[cat.id]}
                      onChange={() => toggle(cat.id)}
                    />
                    <div className="sl-toggle-track" />
                    <div className="sl-toggle-thumb" />
                  </label>
                )}
              </div>
            ))}
            <button className="sl-prefs-save" onClick={savePrefs}>Save My Preferences</button>
          </div>
        )}
      </div>
    </>
  );
}
